var oldJquery = window.jQuery;
window.jQuery = window.$;
require('../../../node_modules/modaal/dist/js/modaal.js');
require('../../../node_modules/owl.carousel/dist/owl.carousel.js');
require('./parallax.js-1.4.2/parallax');
require('./bootstrap.js');
window.aos = require('aos');
window.tippy = require('../../../node_modules/tippy.js/umd/index.js');
window.tippy.setDefaults({
    arrow: true,
    interactive: true,
    trigger: 'click',
    theme: 'light',
    placement: 'bottom'
});
window.URI = require('urijs');
window.Stickyfill = require('stickyfill')();
window.jQuery = oldJquery;
window.lottie = require('lottie-web');
